import { render, staticRenderFns } from "./SpeechAndLanguageAnnexesWrapper.vue?vue&type=template&id=6d8ac22d"
import script from "./SpeechAndLanguageAnnexesWrapper.vue?vue&type=script&lang=js"
export * from "./SpeechAndLanguageAnnexesWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d8ac22d')) {
      api.createRecord('6d8ac22d', component.options)
    } else {
      api.reload('6d8ac22d', component.options)
    }
    module.hot.accept("./SpeechAndLanguageAnnexesWrapper.vue?vue&type=template&id=6d8ac22d", function () {
      api.rerender('6d8ac22d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/appointmentManagement/SpeechAndLanguageAnnexesWrapper.vue"
export default component.exports